import { Component, OnInit , ElementRef, Renderer2, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Location } from '@angular/common';
import { EchexpaymentService } from '../echexpayment.service';
import { LocalstorageService } from '../localstorage.service';

@Component({
  selector: 'echexpayment-emailtemplates',
  templateUrl: './createemailtemplate.component.html',
  styleUrls: ['./emailtemplates.component.css']
})
export class CreateemailtemplateComponent implements OnInit {

  public emailTemplate: any = {status: ""};
	createTemplate: boolean = true;
	editTemplate: boolean = false;
  busy: Subscription;
  private token: string;
  public validation_status_name :boolean = false;
  
  public val_template_name :boolean = false;
  public val_from_name :boolean = false;
  public val_content :boolean = false;
  public val_subject :boolean = false;
  public val_from_email :boolean = false;
  public val_cc_email :boolean = false;
  public val_bcc_email :boolean = false;
  public val_status :boolean = false;
  public invalidfrom_email:boolean = false;
  public invalidcc_email:boolean = false;
  public invalidbcc_email:boolean = false;
  NamecharacterLimitReached: { [key: string]: boolean } = {};
  constructor(private router: Router,private location: Location, private renderer : Renderer2, private elementRef : ElementRef,  private toastr: ToastrService, private echexpaymentService :EchexpaymentService, private localStorageService: LocalstorageService) { 
	this.router = router;
	var currentUser = this.localStorageService.getData("currentUserToken");
	this.token =  currentUser.data.user_token;
  }

  ngOnInit() {
  }
  
  goBack() {
    this.location.back();
  }
  
  eventHandler(){
	this.val_template_name = false;
	this.val_from_name = false;
	this.val_content = false;
	this.val_cc_email = false;
	this.val_bcc_email = false;
	this.val_status = false;
	this.val_subject = false;
	this.val_from_email = false;
	this.invalidfrom_email= false;
	this.invalidcc_email= false;
	this.invalidbcc_email= false;
  }
    
  focusFirstInvalidControlPlus(): void {
    const firstElementWithErrors: HTMLElement = this.elementRef.nativeElement.querySelector(`form .ng-invalid`);
    if (firstElementWithErrors) {
        firstElementWithErrors.focus();
    }
  }

    @ViewChild('submitButton') submitButton: ElementRef;
    moveNext(nextInput: HTMLInputElement, checkbox: number = 0) {
		if(checkbox === 2){
			if (this.submitButton && this.submitButton.nativeElement) {
				this.submitButton.nativeElement.focus();
				this.submitButton.nativeElement.click();
			}
		} else{
		  nextInput && nextInput.focus();
		}
	}

	  
  // Create email template
  createEmailTemplate(data) {
	this.focusFirstInvalidControlPlus();   //focus field
    if(data.valid){
		let model: any = data.value;
		this.val_template_name = false;
		this.val_from_name = false;
		this.val_content = false;
		this.val_subject = false;
		this.val_from_email = false;
		this.val_cc_email = false;
		this.val_bcc_email = false;
		this.val_status = false;
		this.invalidfrom_email= false;
		this.invalidcc_email= false;
		this.invalidbcc_email= false;
	
		var EMAIL_REGEXP = /[a-z0-9!#$%&'*+=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g;

		if(typeof model.template_name === 'undefined'  || model.template_name === null || model.template_name === ''){
		this.val_template_name = true;
		return false;
		}
		if(typeof model.status === 'undefined'  || model.status === null || model.status === ''){
		this.val_status = true;
		return false;
		}
		if(typeof model.from_name === 'undefined'  || model.from_name === null || model.from_name === ''){
		this.val_from_name = true;
		return false;
		}

		if(typeof model.subject === 'undefined'  || model.subject === null || model.subject === ''){
		this.val_subject = true;
		return false;
		}

		if(typeof model.from_email === 'undefined'  || model.from_email === null || model.from_email === ''){
		this.val_from_email = true;
		return false;
		}
		if( !EMAIL_REGEXP.test(model.from_email)){
			this.invalidfrom_email= true;
			return false;
		}
		
		if(typeof model.cc_email === 'undefined'  || model.cc_email === null || model.cc_email === ''){
		//this.val_cc_email = true;
		//return false;
		}

		if( !EMAIL_REGEXP.test(model.cc_email)){
			//this.invalidcc_email = true;
			//return false;
		}
		if(typeof model.bcc_email === 'undefined'  || model.bcc_email === null || model.bcc_email === ''){
		//this.val_bcc_email = true;
		//return false;
		}
		if( !EMAIL_REGEXP.test(model.bcc_email)){
			//this.invalidbcc_email = true;
			//return false;
		}
		if(typeof model.content === 'undefined'  || model.content === null || model.content === ''){
		this.val_content = true;
		return false;
		}
		model.token = this.token;
		let responseData = <any>{};
		this.busy = this.echexpaymentService.createEmailTemplate(model).subscribe(
		response => {
		responseData = response;
				this.toastr.success(responseData.message, 'Success!');
				this.router.navigate(['/email-templates']);
		},
		error => {
				responseData = error;
				this.toastr.error(responseData.error.message, 'Failed!');
		}
		);
	}
  }

  ngAfterViewInit(){
	this.renderer.selectRootElement('#EmailTemplate_Name').focus();
  }

  NameCharacterLimit(event: any, fieldName: string) {
	const maxTextLength = 25; // Maximum text length of 20 characters
	const inputChar = event.key;
	const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
	const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter

	if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
	  return;
	}

	const inputValue = event.target.value;

	if (inputValue.length >= maxTextLength) {
	  if (allowedKeys.indexOf(inputChar) === -1) {
		this.NamecharacterLimitReached[fieldName] = true; // Set the validation flag to true to show the warning message
		setTimeout(() => {
		  this.NamecharacterLimitReached[fieldName] = false; // Hide the warning message after 3 seconds
		}, 3000);
		event.preventDefault(); // Prevent entering the exceeded character
	  }
	}
  }

  isNameLimitReached(fieldName: string): boolean {
	return this.NamecharacterLimitReached[fieldName];
  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/emailtemplates/createemailtemplate.component.ts